import React, { useState } from "react";

function MainFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What types of junk do you remove?",
      answer:
        "We remove almost anything! This includes old furniture, appliances, electronics, yard waste, construction debris, scrap metal, hot tubs, mattresses, and more. If you’re unsure about a specific item, check our services page or give us a call, and we’ll be happy to help!",
    },
    {
      question: "How does your junk removal process work?",
      answer: (
        <ul>
          <li>
            <strong>Schedule a Free Estimate</strong> – Pick a time that works
            best for you.
          </li>
          <li>
            <strong>Get a Free Quote</strong> – We assess the junk, measure how
            much space it will take on the truck, and provide upfront pricing
            with no hidden fees.
          </li>
          <li>
            <strong>We Haul It Away</strong> – Our team does all the heavy
            lifting and removes your junk efficiently.
          </li>
          <li>
            <strong>Payment</strong> – We accept cash, debit/credit cards,
            checks, and Zelle.
          </li>
          <li>
            <strong>Eco-Friendly Disposal</strong> – We recycle, donate, or
            properly dispose of your unwanted items.
          </li>
        </ul>
      ),
    },
    {
      question: "Do you offer same-day or next-day junk removal services?",
      answer:
        "Yes! We offer same-day and next-day junk removal services whenever possible. Availability depends on our schedule, so contact us early to book your spot.",
    },
    {
      question: "How much does junk removal cost?",
      answer:
        "Our pricing is determined by the volume and type of junk being removed. We offer competitive, upfront rates with no hidden fees. Call us today for a free estimate or schedule an in-person assessment at no cost!",
    },
    {
      question:
        "What happens to the junk you collect? Do you recycle or donate items?",
      answer:
        "We are committed to eco-friendly disposal. Items in good condition are donated to local charities, while recyclables are sent to proper facilities. Our goal is to keep as much waste out of landfills as possible.",
    },
  ];

  return (
    <div>
      <main className="pb-0">
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default MainFAQs;
